
    <app-dropdown [id]="id"
                  [options]="options"
                  [showNullOption]="true"
                  [placement]="placement"
                  [(ngModel)]="selection"></app-dropdown>
  